import {
  JiraAllComponentPipelineMapping,
  JiraComponentPipelineMapping,
  ReleaseDecisionInformation,
} from '../../../shared/access-api/access-api.service';

export const getAllJiraComponentPipelineMappingsFlat = (
  configurations: ReleaseDecisionInformation[],
): JiraAllComponentPipelineMapping[] => {
  if (!isJiraComponentPipelineMappingActive(configurations)) {
    return null; // return null if the feature is not active, so that the MDs are maintained manually without jira components
  }
  // create a unique entry for each component-pipelineKey combination
  const allPipelineMappings: JiraAllComponentPipelineMapping[] = [];
  configurations.forEach((config) => {
    config.jiraComponentPipelineMappings?.forEach((mapping) =>
      mapping.pipelineKeys.forEach((pipelineKey) => {
        // Add if the same component-pipelineKey entry does not already exist
        if (!allPipelineMappings.find((entry) => entry.pipelineKey === pipelineKey && entry.component === mapping.component)) {
          allPipelineMappings.push({ pipelineKey: pipelineKey, component: mapping.component });
        }
      }),
    );
  });

  return allPipelineMappings;
};

export const getAllJiraComponentPipelineMappings = (configurations: ReleaseDecisionInformation[]): JiraComponentPipelineMapping[] => {
  if (!isJiraComponentPipelineMappingActive(configurations)) {
    return null; // return null if the feature is not active, so that the MDs are maintained manually without jira components
  }
  // create a unique entry for each component-pipelineKey combination
  const allPipelineMappings: JiraComponentPipelineMapping[] = [];
  configurations.forEach((config) => {
    config.jiraComponentPipelineMappings?.forEach((mapping) => {
      // Add if the same component-pipelineKey entry does not already exist
      const existing = allPipelineMappings.find((entry) => entry.component === mapping.component);
      if (!existing) {
        allPipelineMappings.push({ pipelineKeys: mapping.pipelineKeys, component: mapping.component });
      } else {
        existing.pipelineKeys = [...new Set(existing.pipelineKeys.concat(mapping.pipelineKeys))];
      }
    });
  });
  return allPipelineMappings;
};

const isJiraComponentPipelineMappingActive = (configurations: ReleaseDecisionInformation[]) => {
  return configurations.some((config) => Array.isArray(config.jiraComponentPipelineMappings));
};
